/* unplugin-vue-components disabled */import script from "./IntegralTravelDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./IntegralTravelDetails.vue?vue&type=script&setup=true&lang=js"

import "./IntegralTravelDetails.vue?vue&type=style&index=0&id=67b3d0b4&scoped=true&lang=css"
import "./IntegralTravelDetails.vue?vue&type=style&index=1&id=67b3d0b4&lang=scss"

import exportComponent from "/Users/fubeibei/TRAE_workspace/cuiwei_xcxsc/cw/travel-manage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67b3d0b4"]])

export default __exports__